import * as React from "react";
import {Helmet} from "react-helmet";
import BreadcrumbsBlock from "../layouts/breadcrumbs-block/breadcrumbs-block";
import TitleBlock from "../layouts/title-block/title-block";
import SalaryCalculatorFormBlock from "../layouts/salary-calculator-form-block/salary-calculator-form-block";
import FeaturesBoxSimpleBlock from "../layouts/features-box-simple-block/features-box-simple-block";
import ActionButtonBlock from "../layouts/action-button-block/action-button-block";
import PromoBlock from "../layouts/promo-block/promo-block";
import {PageType, PromoBlockType} from "../models/types";
import { GoogleAnalyticsEventType } from "../models/google-analytics";
import * as staticUrls from "../constants/static-urls";
import * as featuresData from "../constants/features-data";
import * as testimonialsData from "../constants/testimonials-data";
import * as helmetData from "../constants/helmet-data";
import * as cacheBustingService from "../services/cache-busting-service";

interface KalkulatorWynagrodzenPageProps {}

interface KalkulatorWynagrodzenPageState {}

class KalkulatorWynagrodzenPage extends React.Component<KalkulatorWynagrodzenPageProps, KalkulatorWynagrodzenPageState> {

    componentDidMount() {
        cacheBustingService.handleCacheBusting(caches)
    }

    render() {
        return (
            <div>
                <Helmet {...helmetData.prepareHelmetData(PageType.KalkulatorWynagrodzenPage)}/>

                <TitleBlock
                    firstLineBlackStart={"Kalkulator"}
                    firstLineBlue={"wynagrodzeń"}
                    firstLineBlackEnd={""}
                    secondLineText={"Porównaj dostępne formy zatrudnienia"}
                />

                <SalaryCalculatorFormBlock/>

                <PromoBlock
                    promoBlockType={PromoBlockType.PromoBlockGrayBox}
                    promoBlockTitle={"NIE CZEKAJ, WYPRÓBUJ FAKTUROMANIĘ JUŻ DZIŚ"}
                    promoBlockText={"Przekonaj się jak prosta może być pełna księgowość online."}
                    promoBlockButtonText={"WYPRÓBUJ ZA DARMO"}
                    promoBlockLink={staticUrls.FAKTUROMANIA_REGISTRATION_PAGE_URL}
                />
            </div>
        );
    }

}

export default KalkulatorWynagrodzenPage


// WEBPACK FOOTER //
// ./src/pages/kalkulator-wynagrodzen.tsx